/*
 * Safely parses Business Manager category color config (c_categoryTextColor).
 * Expected format: { "textColor": "#FFFFFF", "hoverColor": "#FFF435" }
 *
 * Returns null (so callers fall back to defaults) when:
 * - value is null/undefined
 * - value is invalid JSON or throws on parse
 * - parsed value is not a plain object (e.g. array, number, string)
 * - textColor/hoverColor are missing, wrong type, or empty after trim
 *
 * @param {string|object} value - Raw value from BM (stringified JSON or already parsed object)
 * @returns {{ textColor?: string, hoverColor?: string } | null}
 */
export const parseCategoryColorConfig = (value) => {
    if (value == null) return null
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value
        // Reject null, non-objects, and arrays (wrong structure)
        if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return null
        }
        const result = {}
        // Only accept non-empty strings for each key
        if (typeof parsed.textColor === 'string' && parsed.textColor.trim()) {
            result.textColor = parsed.textColor.trim()
        }
        if (typeof parsed.hoverColor === 'string' && parsed.hoverColor.trim()) {
            result.hoverColor = parsed.hoverColor.trim()
        }
        return Object.keys(result).length ? result : null
    } catch {
        return null
    }
}
